<ion-header class="ion-no-border">
  <ion-toolbar color="primary">
    <ion-title>
      <span [ngSwitch]="mode">
        <span *ngSwitchCase="'insert'">Aggiungi terapia</span>
        <span *ngSwitchCase="'insertByAV'">Aggiungi terapia</span>
        <span *ngSwitchCase="'edit'">Modifica terapia</span>
        <span *ngSwitchCase="'view'">Dettagli terapia</span>
        <span *ngSwitchDefault>Terapia</span>
      </span>
      <span *ngIf="data.insulinTherapy"> insulinica</span>
      <span *ngIf="data.oncoTherapy"> oncologica</span>
    </ion-title>

    <ion-buttons slot="end">
      <!-- edit mode -->
      <!-- cannot edit in insert mode -->
      <!-- cannot edit suspended therapy -->
      <!-- cannot edit ended therapy -->
      <ng-container
        *ngIf="
          mode !== 'insert' &&
          data.therapy?.data.state !== 'inactive' &&
          !data.therapy?.isTerminated &&
          !isAI
        "
      >
        <ion-button
          (click)="mode = mode === 'edit' ? 'view' : 'edit'"
          [color]="mode === 'edit' ? '' : 'secondary'"
        >
          <span>{{ !(mode === "edit") ? "Abilita" : "Disabilita" }} modifica</span>
          <ion-icon
            slot="end"
            [src]="(mode === 'edit' ? 'pencil-off' : 'pencil') | getIcon"
          ></ion-icon>
        </ion-button>
      </ng-container>

      <!-- close -->
      <ion-button (click)="onClose()">
        <ion-icon slot="icon-only" [src]="'close' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row
      *ngIf="
        mode === 'insert' &&
        (data.context?.includes(CTX_ONCO) || data.context?.includes(CTX_ONCOLOGY_BREAST_CANCER)) &&
        !data.oncoTherapy
      "
    >
      <ion-col size="12">
        <div class="c3-flex ion-align-items-center">
          <ion-icon
            size="large"
            [src]="'text-box-multiple-outline' | getIcon"
            class="ion-margin-end"
          ></ion-icon>
          <h4 class="ion-margin-top ion-margin-bottom">Utilizza uno schema terapeutico</h4>
        </div>

        <ion-note>
          Scegli uno schema terapeutico da utilizzare per precompilare i parametri richiesti da
          questa terapia farmacologica.
        </ion-note>

        <div class="ion-margin-top">
          <c3-therapy-template-selector
            [searchPending]="ttSearchLoading$ | async"
            [searchResults]="ttSearchResults$ | async"
            (search)="onTherapyTemplateGroupSearch($event)"
            (selected)="onTherapyTemplateGroupSelected($event)"
          >
          </c3-therapy-template-selector>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <!-- generic form -->
        <ng-container *ngIf="!data.oncoTherapy">
          <div *ngIf="therapyTemplateGroup?.therapies.length > 1" class="ion-margin-bottom">
            <app-hint-msg>
              Lo schema terapeutico scelto prevede la somministrazione di
              {{ therapyTemplateGroup?.therapies.length }}
              terapie differenti. Qua sotto sono riportati i campi da completare per tutte le
              terapie da prescrivere.
            </app-hint-msg>
          </div>

          <!-- {{ data.therapy | json }}
          {{ mode }} -->
          <c3-form-therapy
            *ngIf="!therapyTemplateGroup; else ttgTmpl"
            [mode]="mode"
            [item]="data.therapy"
            [insulinTherapy]="data.insulinTherapy"
            [context]="data.context"
            [insertDefaults]="data.insertDefaults"
            [AIFlag]="isAI"
          >
          </c3-form-therapy>

          <ng-template #ttgTmpl>
            <ng-container *ngFor="let tt of therapyTemplateGroup?.therapies; let i = index">
              <div class="c3-divider ion-margin-top"></div>

              <ion-grid>
                <ion-row #tBox class="ion-align-items-center ion-justify-content-between">
                  <ion-col>
                    <h3>{{ i + 1 }}° Terapia a base di {{ tt.drug.active_ingredient }}</h3>
                  </ion-col>

                  <ion-col size="auto">
                    <app-form-valid-tick
                      [formValid]="ttForm.form.valid"
                      [formTouched]="ttForm.form.touched"
                    >
                    </app-form-valid-tick>
                  </ion-col>

                  <ion-col size="auto">
                    <ion-button (click)="$any(tBox)._c3Hide = !$any(tBox)._c3Hide" fill="clear">
                      <ng-container *ngIf="!$any(tBox)._c3Hide">
                        <span>Nascondi</span>
                        <ion-icon slot="end" [src]="'chevron-up' | getIcon"></ion-icon>
                      </ng-container>
                      <ng-container *ngIf="$any(tBox)._c3Hide">
                        <span>Mostra</span>
                        <ion-icon slot="end" [src]="'chevron-down' | getIcon"></ion-icon>
                      </ng-container>
                    </ion-button>
                  </ion-col>
                </ion-row>

                <ion-row [ngClass]="{ 'ion-hide': $any(tBox)._c3Hide }">
                  <ion-col size="12">
                    <c3-form-therapy
                      #ttForm
                      [mode]="mode"
                      [insulinTherapy]="data.insulinTherapy"
                      [context]="data.context"
                      [insertDefaults]="data.insertDefaults"
                      [therapyTemplate]="tt"
                    >
                    </c3-form-therapy>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ng-container>
          </ng-template>
        </ng-container>

        <!-- onco therapy form -->
        <c3-form-therapy-oncological
          *ngIf="data.oncoTherapy"
          [mode]="mode"
          [item]="data.therapy"
          [context]="data.context"
        >
        </c3-form-therapy-oncological>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <div slot="start" class="ion-margin-start">
      <app-form-valid-tick [formValid]="formsValid" [formTouched]="formsTouched">
      </app-form-valid-tick>
    </div>

    <ion-buttons slot="end" class="ion-margin-end">
      <ion-spinner *ngIf="loading$ | async" color="secondary"></ion-spinner>
      <!-- Valid {{formsValid}}
      Pristine {{formsPristine}} -->
      <ion-button
        type="submit"
        *ngIf="mode !== 'view'"
        color="secondary"
        (click)="onSubmit(formItems)"
        [disabled]="!formsValid || formsPristine || (loading$ | async)"
      >
        <ion-icon slot="start" [src]="'content-save' | getIcon"></ion-icon>
        <span>Salva Terapia</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
